export enum PassportLocalStorage {
  ACCESS_TOKEN = "credenza:passport:accessToken",
  QR_CODE = "credenza:passport:qrCode",
}